var p = Object.defineProperty;
var h = (r, t, e) => t in r ? p(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var n = (r, t, e) => (h(r, typeof t != "symbol" ? t + "" : t, e), e);
class R {
  constructor(t) {
    n(this, "baseApiURL");
    n(this, "storeURL");
    this.baseApiURL = t.baseApiURL || "https://api.sandbox.slashid.com", this.storeURL = t.storeURL;
  }
  createRequestOptions({
    slashIDToken: t,
    multipassFields: e
  }) {
    const s = {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${t}`,
        "Content-Type": "application/json"
      }
    };
    return e && Object.keys(e).length > 0 && (s.headers = {
      ...s.headers
    }, s.body = JSON.stringify(e)), s;
  }
  /**
   * Fetches a Shopify Multipass token from SlashID. Requires a valid SlashID token and external credential ID.
   */
  async getMultipassToken({
    slashIDToken: t,
    externalCredentialID: e,
    multipassFields: s
  }) {
    const i = this.createRequestOptions({
      slashIDToken: t,
      multipassFields: s
    }), o = await fetch(
      `${this.baseApiURL}/shopify-multipass/${e}`,
      i
    ), a = await o.json();
    if (!o.ok) {
      const c = a && a.errors || o.status;
      return Promise.reject(c);
    }
    return a.result;
  }
  /**
   * Fetches a Shopify customer access token from SlashID. Requires a valid SlashID token and external credential ID.
   */
  async getCustomerAccessToken({
    slashIDToken: t,
    externalCredentialID: e
  }) {
    const s = this.createRequestOptions({ slashIDToken: t }), i = await fetch(
      `${this.baseApiURL}/shopify-multipass/${e}/customer-access-token`,
      s
    ), o = await i.json();
    if (!i.ok) {
      const a = o && o.errors || i.status;
      return Promise.reject(a);
    }
    return o.result;
  }
  navigateToShopify(t) {
    let e = `${this.storeURL}/account/login/multipass/${t}`;
    window.location.href = e;
  }
}
export {
  R as ShopifySDK
};
//# sourceMappingURL=main.js.map
